import { type FC } from "react";
import { Box, CircularProgress, DialogContent } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DialogHeader } from "@/shared/components";

/**
 * Тело диалога, пока нет ни данных, ни (позже) чанка редактора: заголовок
 * с индикатором и спиннер. Используется и как начальное состояние
 * `AutomationDialog` (данные ещё не пришли), и как фолбэк `Suspense`
 * вокруг ленивого `AutomationEditor` внутри того же диалога (Review I4:
 * отдельного диалога-обёртки для состояния загрузки больше нет, чтобы не
 * было двойного открытия/затухания при первом входе).
 */
export const AutomationDialogLoadingContent: FC<{ onClose: () => void }> = ({
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <DialogHeader
        title={t("automations.editor.title")}
        loading
        onClose={onClose}
      />
      <DialogContent>
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      </DialogContent>
    </>
  );
};
